module.exports = __webpack_public_path__ + "static/media/Levin Fabric Chair_Dark Grey.10e0673e.png";